/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as React from "react";
import styled from "styled-components";
import { Box, theme } from "@nordcloud/gnui";
import { noop } from "~/tools";

type Props = {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  selected?: boolean;
  isSaveSetting?: boolean;
  minHeight?: string;
};

export function SelectableBox({
  children,
  selected = false,
  isSaveSetting = false,
  minHeight,
  onClick = noop,
}: Props) {
  return (
    <ContentWrapper
      onClick={onClick}
      selected={selected}
      isSaveSetting={isSaveSetting}
    >
      <Box minHeight={minHeight} boxStyle="lightGrey">
        {children}
      </Box>
    </ContentWrapper>
  );
}

const ContentWrapper = styled.div<{
  selected: boolean;
  isSaveSetting: boolean;
}>`
  > div {
    padding: ${theme.spacing.spacing03};
    background-color: ${theme.color.background.ui02};
    cursor: pointer;
    border-top-width: 0.25rem;
    border-top-color: ${({ selected }) =>
      selected ? theme.color.interactive.primary : theme.color.border.input};

    &:hover {
      background-color: ${({ isSaveSetting }) =>
        !isSaveSetting ? theme.color.background.ui04 : `initial`};
    }
  }
`;
